import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "../../helpers/URLS";
import useAxios from "../../helpers/Hooks/useAxios";
import NavDropdown from "react-bootstrap/NavDropdown";
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import NotificationPanel from "../Notifications/Notification-Panel";
import { downloadLink } from "../../helpers/constFIles";
import "./AdminHeader.scss";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedinUser } from "../../Redux/reducer";

const AdminHeader = ({ setToggle, toggle, user }) => {

  const { fetchData } = useAxios();
const dispatch=useDispatch()
  const navigate = useNavigate();

  const x = Array.from(user.employee.employeeName || "?")[0];
  const role = user.employee?.totalData?.designation || user.employee?.designation || "";

  /* Prefer the store, which the profile page updates the moment a new
     picture is saved; the prop is the value this page loaded with. */
  const storedPic = useSelector((state) => state.WorkHubAppSlice?.user?.employee?.profilePic);
  const profilePic = storedPic !== undefined ? storedPic : user.employee?.profilePic;

  const photoUrl = profilePic ? downloadLink + profilePic : "";

  const [openNotitficationPanel, setOpenNotificationPanel] = useState(false);

  const [data, setData] = useState("")

  const getValue = (person) => {
    setData(person)
  }

  return (
    <div className="w-100">
      <div className="container-fluid p-0">
        <div className="wh-appbar">
          <Tooltip title={toggle ? "Collapse menu" : "Expand menu"} placement="right" arrow>
            <button type="button" className="wh-appbar-toggle"
              aria-label={toggle ? "Collapse menu" : "Expand menu"}
              onClick={() => setToggle(!toggle)}>
              {toggle ? <MenuOpenRoundedIcon /> : <MenuRoundedIcon />}
            </button>
          </Tooltip>

          <div className="wh-appbar-actions">
            <Tooltip title="Notifications" placement="bottom" arrow>
              <button type="button" className="wh-appbar-icon"
                aria-label="Notifications"
                onClick={() => { setOpenNotificationPanel(true) }}>
                <Badge color="error" badgeContent={data}>
                  <NotificationsNoneRoundedIcon />
                </Badge>
              </button>
            </Tooltip>
            <div className="big_dropdown wh-account">
              <NavDropdown
                eventkey={1}
                title={
                  <span className="wh-account-chip">
                    <Avatar className="wh-account-avatar" sx={{ width: 34, height: 34 }}
                      src={photoUrl || undefined}
                      alt={user.employee.employeeName}>{x}</Avatar>
                    <span className="wh-account-text">
                      <b>{user.employee.employeeName}</b>
                      {role && <em>{role}</em>}
                    </span>
                    <KeyboardArrowDownRoundedIcon className="wh-account-caret" />
                  </span>
                }
                id="basic-nav-dropdown"
              >
                <div className="wh-account-head">
                  <b>{user.employee.employeeName}</b>
                  <span>{user.employee.emailID}</span>
                </div>
                <NavDropdown.Item eventkey={1.1} onClick={() => { navigate('/profile') }}>
                  <PersonOutlineRoundedIcon />Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventkey={1.3}
                  onClick={async (e) => {
                    e.preventDefault();
                    try {
                      const resp = await fetchData({
                        url: URLS.logout,
                        method: "get",
                      });
                      if (resp.status === 200) {
                        dispatch(setLoggedinUser({}))
                        navigate("/login");
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <LogoutRoundedIcon />Logout
                </NavDropdown.Item>
              </NavDropdown>
            </div>
            <div className="small_dropdown wh-account">
              <NavDropdown
                eventkey={1}
                title={
                  <span className="wh-account-chip">
                    <Avatar className="wh-account-avatar" sx={{ width: 34, height: 34 }}
                      src={photoUrl || undefined}
                      alt={user.employee.employeeName}>{x}</Avatar>
                  </span>
                }
                id="basic-nav-dropdown">
                <div className="wh-account-head">
                  <b>{user.employee.employeeName}</b>
                  <span>{user.employee.emailID}</span>
                </div>
                <NavDropdown.Item eventkey={1.1} href="/profile">
                  <PersonOutlineRoundedIcon />Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventkey={1.3}
                  onClick={async (e) => {
                    e.preventDefault();
                    try {
                      const resp = await fetchData({ url: URLS.logout, method: "get" });
                      if (resp.status === 200) {
                        navigate("/");
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <LogoutRoundedIcon />Logout
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </div>
        </div>
      </div>
      <NotificationPanel getValue={getValue} openNotitficationPanel={openNotitficationPanel} setOpenNotificationPanel={setOpenNotificationPanel} />
    </div>
  )
}

export default AdminHeader